<template>
  <div class="container">
    <ContentLoader
      ref="contentLoader"
      :profile-owner="profileOwner"
      :load-fn="loadFn"
      :process-content-fn="false"
      content-name="items"
    >
      <template slot-scope="props">
        <div
          v-if="permissions.isOwner"
          class="row mb-6"
        >
          <VsButton
            type="primary"
            icon="fa:plus"
            :tracker="{
              category: 'playlist',
              action: 'open-create',
            }"
            @click="addNewPlaylist"
          >
            {{
              $t('playlist.actions.create', {
                item: $t('playlist.label', { count: 0 })
              })
            }}
          </VsButton>
        </div>
        <div class="row">
          <div
            v-for="playlist in getFilteredPropContent(props)"
            :key="playlist.slug"
            class="col-12 col-md-6 col-xl-4"
          >
            <PlaylistsViewItem
              class="mb-5"
              :playlist="playlist"
              :base-url="baseUrl"
              :use-router="true"
            />
          </div>
        </div>
      </template>
      <ProfileVideosEmptyState
        slot="empty"
        :options="emptyStateOptions"
      >
        <VsButton
          v-if="permissions.isOwner"
          type="primary"
          :tracker="{
            category: 'playlist',
            action: 'open-create',
          }"
          @click="addNewPlaylist"
        >
          {{ $t('common.click_here') }}
          {{ $t('common.to') }}
          {{ $t('playlist.actions.create', { item: $t('playlist.label', { count: 0 }) }) }}
        </VsButton>
      </ProfileVideosEmptyState>
    </ContentLoader>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { Model, Request } from '@viddsee/server-api-client';
import { UserInfoCompat } from '@/scripts/libs/login/userResponseProcessor';

import VsButton from '@/scripts/Components/Molecules/VsButton.vue';
import playlist from '@/scripts/libs/playlist';
//
import PlaylistsViewItem from './PlaylistsViewItem.ts.vue';
import ContentLoader from '../ContentLoader.ts.vue';
import ProfileVideosEmptyState from '../../ProfileVideosEmptyState.vue';
import { usersApi } from '@/scripts/webcall/v3/users';

interface EmptyStateOptions {
  name: string;
  title: string;
  message: string;
}

export default Vue.extend({
  components: {
    VsButton,
    PlaylistsViewItem,
    ContentLoader,
    ProfileVideosEmptyState,
  },
  props: {
    profileOwner: {
      type: Object as PropType<UserInfoCompat>,
      required: true,
    },
    permissions: {
      type: Object as PropType<Record<string, boolean | undefined>>,
      required: true,
    },
  },
  computed: {
    emptyStateOptions(): EmptyStateOptions {
      return {
        name: 'no-playlist',
        title: this.$t('profile.empty_state.playlists.title'),
        message: this.permissions.isOwner
          ? ''
          : this.$t('profile.empty_state.playlists.message.other', { name: this.profileOwner.profile.firstName }),
      };
    },
    baseUrl(): string | undefined {
      return this.$route.params.id ? undefined : '/profile/playlists';
    },
  },

  methods: {
    async loadFn({ params }: any): Promise<Model.Pagination.PaginatedItemsResponse<Model.Playlist.VideoCollectionInfo>> {
      const { data: response } = await usersApi.playlists.list(
        {
          userVanity: params.id,
        },
        {
          imageSize: 'small',
          coversPerList: 3,
          order: Request.Pagination.OptionOrder.Descending,
          ...params,
        },
      );
      return response;
    },

    addNewPlaylist(): void {
      playlist.openPlaylistCreationModal(
        (playlist) => {
          const contentLoader = this.$refs.contentLoader as InstanceType<typeof ContentLoader>;
          contentLoader.addContent(playlist);
        },
        (error) => {
          this.$store.dispatch('notification/notify', {
            type: 'error',
            title: error.message,
          });
        },
      );
    },
    getFilteredPropContent(props: { content: Model.Playlist.VideoCollectionInfo[] }): Model.Playlist.VideoCollectionInfo[] {
      return (
        props.content
          .filter(playlist => !playlist.isPrivate || this.permissions.isOwner)
      );
    },
  },
});
</script>

<style lang="scss">

</style>
